export const pageTitles = {
  home: "Manufacturer of advanced intermediates of API's | Indian pharmaceutical company | Modepro India Pvt. Ltd",
  about: "Modepro India | About Us",
  products: "Modepro India | Products",
  rnd: "Modepro India |  R & D",
  manufacturing: "Modepro India | Manufacturing",
  quality: "Modepro India | Quality",
  ehs: "Modepro India | EHS",
  capabilities: "Modepro | Capabilities",
  careers: "Modepro India | Careers",
  gallery: "Modepro | Gallery",
  contact: "Modepro | Contact Us",
} as const;
